import { createGlobalState } from 'react-hooks-global-state';
import defaultGame from './game/defaultState';
import defaultMoves from './moves/defaultState';

const initalState = { game: defaultGame, moves: defaultMoves };
export const { useGlobalState } = createGlobalState(initalState);
